import { ArrowRightOutlined } from '@ant-design/icons'
import type { ICellRendererParams } from 'ag-grid-community'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'

export function TerminalsCellRenderer({ data }: ICellRendererParams<Match>) {
  if (!data?.terminals || !Array.isArray(data.terminals) || data.terminals.length === 0) {
    return null
  }

  return (
    <div>
      {data.terminals.map((terminal, i) => {
        const showArrow = i !== data.terminals!.length - 1
        return (
          <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
            {terminal}
            {showArrow && <ArrowRightOutlined style={{ color: 'var(--theme-color-2)' }} className='pl-1 pr-2' />}
          </div>
        )
      })}
    </div>
  )
}
